import { VisitFinishApprovedCommand } from '@dreryk/egabinet-visit-frontend-api';

import { Button, ButtonVariant, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import {
   visitActionBarTranslationKeys,
   visitDetailsTranslationKeys,
   visitTranslationKeys,
} from '../../../../translations';
import { useVisitPushBack } from '../../visitForm.hooks';
import { VisitFormSubmitHandler } from '../../visitForm.types';
import { useVisitCommand } from '../shared/confirmVisit.hooks';

import { withConfirmVisitActionInterceptors } from './ConfirmVisitAction.interceptors';

export type ConfirmVisitActionProps = {
   handleSubmit: VisitFormSubmitHandler;
   waiting: boolean;
   visitId: number;
};

export const ConfirmVisitAction = withConfirmVisitActionInterceptors((props) => {
   const pushBack = useVisitPushBack();
   const { executeAsync: executeVisitCommand } = useVisitCommand(VisitFinishApprovedCommand, {
      visitId: props.visitId,
      onSuccess: () => {
         dispatchSnackbarPositiveEvent(visitDetailsTranslationKeys.visitConfirmed);
         pushBack();
      },
   });

   return (
      <Button
         order={1}
         compact
         testId={'confirmVisit'}
         label={visitActionBarTranslationKeys.confirm}
         variant={ButtonVariant.SECONDARY}
         onClick={props.handleSubmit(executeVisitCommand)}
         blockingOperation={visitTranslationKeys.confirmingVisit}
         disabled={props.waiting}
      />
   );
});
